// @vendors
const Immutable = require('immutable');

// @helpers
const { formatText } = require('core/i18n').i18n;
const { isRenderStep0 } = require('mifid/utilities/mifidValidHelper');
const { getStore } = require('core/storeHelper');
const { shouldCoherenceControl } = require('mifid/utilities/mifidValidHelper');

// @constants
const {
    WIZARD_FIRST_STEP,
    WIZARD_SECOND_STEP,
    WIZARD_THIRD_STEP,
    FIRST_STEP,
    SECOND_STEP,
    THIRD_STEP,
    FOURTH_STEP,
    BROKER_CONVENIENCE_MIFID_TEST_FIRST_STEP_STUDY_UNIVERSITARY_ANSWER,
    BROKER_CONVENIENCE_MIFID_TEST_FIRST_STEP_EXPERIENCE_MORE_THAN_A_YEAR_ANSWER,
    BROKER_CONVENIENCE_MIFID_TEST_FIRST_STEP_EXPERIENCE_WITH_KNOWLEDGE_ANSWER,
    BROKER_CONVENIENCE_MIFID_TEST_SECOND_STEP_FINANCIAL_CULTURE_NONE_ANSWER,
    BROKER_CONVENIENCE_MIFID_TEST_SECOND_STEP_FINANCIAL_CULTURE_GENERAL_CONCEPTS_ANSWER,
    BROKER_CONVENIENCE_MIFID_TEST_THIRD_STEP_FIXED_INCOME_WITH_IMPLIED_DERIVATIVES_TWO_OR_MORE_ANSWER,
    BROKER_CONVENIENCE_MIFID_TEST_THIRD_STEP_DERIVATIVES_OTC_TWO_OR_MORE_ANSWER,
    BROKER_CONVENIENCE_MIFID_TEST_THIRD_STEP_DERIVATIVES_OTC_QUESTION_ID,
    BROKER_CONVENIENCE_MIFID_TEST_THIRD_STEP_FIXED_INCOME_WITH_IMPLIED_DERIVATIVES_QUESTION_ID,
    BROKER_CONVENIENCE_MIFID_TEST_FETCH_CURRENT_TEST_RESULT_FETCHING,
    BROKER_CONVENIENCE_MIFID_TEST_FETCH_CURRENT_TEST_RESULT_SUCCESS_APPROVED,
} = require('constants/index');

const {
    BROKER_CONVENIENCE_MIFID_TEST_STEP3_CHECK_INCOHERENCES,
    BROKER_CONVENIENCE_MIFID_TEST_STEP3_CONTINUE_WITH_INCOHERENCES,
} = require('mifid/constants/actionTypes');

const {
    BROKER_CONVENIENCE_MIFID_TEST_STEP3_VERIFY_ANSWERS,
    BROKER_CONVENIENCE_MIFID_TEST_STEP3_CLOSE_INVALID_ANSWERS_MODAL,
    BROKER_CONVENIENCE_MIFID_TEST_VALIDATE_STEP,
    BROKER_CONVENIENCE_MIFID_TEST_STEP3_CHANGE_EXPERIENCE_AS_INVESTOR,
    BROKER_CONVENIENCE_MIFID_TEST_CONSULT,
} = require('constants/actionTypes');

// @hardcoded
const getInitialState = () => {
    const INITIAL_STATE = Immutable.fromJS({
        products: [
            {
                id: '145',
                orden: '3',
                name: formatText('broker-convenienceMifidTestBankDeposits'),
                answer: '',
                answers: [
                    {
                        id: '146',
                        description: formatText('broker-convenienceMifidTestTwoOrMore')
                    },
                    {
                        id: '147',
                        description: formatText('broker-convenienceMifidTestOnlyOne')
                    },
                    {
                        id: '148',
                        description: formatText('broker-convenienceMifidTestNone')
                    }
                ],
                valid: false
            },
            {
                id: '149',
                orden: '4',
                name: formatText('broker-convenienceMifidTestPublicPrivateRent'),
                answer: '',
                answers: [
                    {
                        id: '150',
                        description: formatText('broker-convenienceMifidTestTwoOrMore')
                    },
                    {
                        id: '151',
                        description: formatText('broker-convenienceMifidTestOnlyOne')
                    },
                    {
                        id: '152',
                        description: formatText('broker-convenienceMifidTestNone')
                    }
                ],
                valid: false
            },
            {
                id: '153',
                orden: '5',
                name: formatText('broker-convenienceMifidTestVariableRent'),
                answer: '',
                answers: [
                    {
                        id: '154',
                        description: formatText('broker-convenienceMifidTestTwoOrMore')
                    },
                    {
                        id: '155',
                        description: formatText('broker-convenienceMifidTestOnlyOne')
                    },
                    {
                        id: '156',
                        description: formatText('broker-convenienceMifidTestNone')
                    }
                ],
                valid: false
            },
            {
                id: '157',
                orden: '6',
                name: formatText('broker-convenienceMifidTestFundPlansInsurers'),
                answer: '',
                answers: [
                    {
                        id: '158',
                        description: formatText('broker-convenienceMifidTestTwoOrMore')
                    },
                    {
                        id: '159',
                        description: formatText('broker-convenienceMifidTestOnlyOne')
                    },
                    {
                        id: '160',
                        description: formatText('broker-convenienceMifidTestNone')
                    }
                ],
                valid: false
            },
            {
                id: '161',
                orden: '7',
                name: formatText('broker-convenienceMifidTestStructuredProductsWarranty'),
                answer: '',
                answers: [
                    {
                        id: '162',
                        description: formatText('broker-convenienceMifidTestTwoOrMore')
                    },
                    {
                        id: '163',
                        description: formatText('broker-convenienceMifidTestOnlyOne')
                    },
                    {
                        id: '164',
                        description: formatText('broker-convenienceMifidTestNone')
                    }
                ],
                valid: false
            },
            {
                id: '165',
                orden: '8',
                name: formatText('broker-convenienceMifidTestStructuredProductsWithoutWarranty'),
                answer: '',
                answers: [
                    {
                        id: '166',
                        description: formatText('broker-convenienceMifidTestTwoOrMore')
                    },
                    {
                        id: '167',
                        description: formatText('broker-convenienceMifidTestOnlyOne')
                    },
                    {
                        id: '168',
                        description: formatText('broker-convenienceMifidTestNone')
                    }
                ],
                valid: false
            },
            {
                id: '169',
                orden: '9',
                name: formatText('broker-convenienceMifidTestConvertibleBonds'),
                answer: '',
                answers: [
                    {
                        id: '170',
                        description: formatText('broker-convenienceMifidTestTwoOrMore')
                    },
                    {
                        id: '171',
                        description: formatText('broker-convenienceMifidTestOnlyOne')
                    },
                    {
                        id: '172',
                        description: formatText('broker-convenienceMifidTestNone')
                    }
                ],
                valid: false
            },
            {
                id: BROKER_CONVENIENCE_MIFID_TEST_THIRD_STEP_FIXED_INCOME_WITH_IMPLIED_DERIVATIVES_QUESTION_ID,
                orden: '10',
                name: formatText('broker-convenienceMifidTestPreferentialParticipations'),
                answer: '',
                answers: [
                    {
                        id: BROKER_CONVENIENCE_MIFID_TEST_THIRD_STEP_FIXED_INCOME_WITH_IMPLIED_DERIVATIVES_TWO_OR_MORE_ANSWER,
                        description: formatText('broker-convenienceMifidTestTwoOrMore')
                    },
                    {
                        id: '175',
                        description: formatText('broker-convenienceMifidTestOnlyOne')
                    },
                    {
                        id: '176',
                        description: formatText('broker-convenienceMifidTestNone')
                    }
                ],
                valid: false
            },
            {
                id: '177',
                orden: '11',
                name: formatText('broker-convenienceMifidTestRealEstate'),
                answer: '',
                answers: [
                    {
                        id: '178',
                        description: formatText('broker-convenienceMifidTestTwoOrMore')
                    },
                    {
                        id: '179',
                        description: formatText('broker-convenienceMifidTestOnlyOne')
                    },
                    {
                        id: '180',
                        description: formatText('broker-convenienceMifidTestNone')
                    }
                ],
                valid: false
            },
            {
                id: '181',
                orden: '12',
                name: formatText('broker-convenienceMifidTestVentureCapitalProduct'),
                answer: '',
                answers: [
                    {
                        id: '182',
                        description: formatText('broker-convenienceMifidTestTwoOrMore')
                    },
                    {
                        id: '183',
                        description: formatText('broker-convenienceMifidTestOnlyOne')
                    },
                    {
                        id: '184',
                        description: formatText('broker-convenienceMifidTestNone')
                    }
                ],
                valid: false
            },
            {
                id: '185',
                orden: '13',
                name: formatText('broker-convenienceMifidTestDerivativesOrganizedMarkets'),
                answer: '',
                answers: [
                    {
                        id: '186',
                        description: formatText('broker-convenienceMifidTestTwoOrMore')
                    },
                    {
                        id: '187',
                        description: formatText('broker-convenienceMifidTestOnlyOne')
                    },
                    {
                        id: '188',
                        description: formatText('broker-convenienceMifidTestNone')
                    }
                ],
                valid: false
            },
            {
                id: BROKER_CONVENIENCE_MIFID_TEST_THIRD_STEP_DERIVATIVES_OTC_QUESTION_ID,
                orden: '14',
                name: formatText('broker-convenienceMifidTestOTCDerivatives'),
                answer: '',
                answers: [
                    {
                        id: BROKER_CONVENIENCE_MIFID_TEST_THIRD_STEP_DERIVATIVES_OTC_TWO_OR_MORE_ANSWER,
                        description: formatText('broker-convenienceMifidTestTwoOrMore')
                    },
                    {
                        id: '191',
                        description: formatText('broker-convenienceMifidTestOnlyOne')
                    },
                    {
                        id: '192',
                        description: formatText('broker-convenienceMifidTestNone')
                    }
                ],
                valid: false
            }
        ],
        summaryTitle: formatText('broker-convenienceMifidTestExperienceAsInvestor'), // @hardcoded
        summaryDescription: [],
        valid: false,
        validated: false,
        invalidAnswersModalVisible: false,
        invalidAnswersModalTitle: '',
        invalidAnswersModalMessage: '',
        stepToCheckAnswer: -1,
        showCoherenceModal: false,
        controlCurrTest: false,
        shouldValidateCoherence: true,
    });

    return INITIAL_STATE
}

/**
 * Answers from step 3 are incorrect if
 * - Answer from question 'Financial culture' (step 2) is 'No financial experience'
 * - Answers from questions in step 3 from range F to L are '2 or more years'
 * @param {Immutable.List} immSteps
 * @returns {boolean}
 */
const answersStep3Incorrect = immSteps => {
    const QUESTION_F = 4;
    const QUESTION_L = 12;
    const isStep0 = isRenderStep0();
    const thirdStep = isStep0 ? FOURTH_STEP : THIRD_STEP;
    const secondStep = isStep0 ? THIRD_STEP : SECOND_STEP;

    const immStep3Questions = immSteps.getIn([thirdStep, 'products']);
    const immQuestionsToValidate = immStep3Questions.slice(QUESTION_F, QUESTION_L);
    const answerTwoOrMoreYears = (immQuestion) => immQuestion.get('answer') === immQuestion.getIn(['answers', '0', 'id']);

    const financialCultureNoneAnswer = BROKER_CONVENIENCE_MIFID_TEST_SECOND_STEP_FINANCIAL_CULTURE_NONE_ANSWER;
    const financialCultureAnswer = immSteps.getIn([secondStep, 'financialCulture', 'answer']);
    const hasNoFinancialCulture = financialCultureAnswer === financialCultureNoneAnswer;

    return hasNoFinancialCulture && !!immQuestionsToValidate.find(answerTwoOrMoreYears);
};

function closeIncoherenceModal(immState) {
    return immState.set('showCoherenceModal', false)
}

function continueWithIncoherences(immState) {
    return immState
        .set('valid', true)
        .set('shouldValidateCoherence', false)
        .set('showCoherenceModal', false);
}


function validateByID(immPreviousTest, immCurrentTest, questionID) {
    const immPreviousQuestion = immPreviousTest.find((immQuestion) => {
        return immQuestion.get('id') === questionID
    })
    const immPreviousAnswers = !!immPreviousQuestion && immPreviousQuestion.getIn(['respuestasArray', 'respuestasArray']);
    const immPreviousAnswerSelected = !!immPreviousQuestion && immPreviousAnswers.toArray()
    .find((immAnswer) => {
        return immAnswer.get("seleccionado") === "S";
    });

    const currentAnswers = immCurrentTest.find(immQuestion => {
        return immQuestion.get('id') === questionID
    }).get('answers');

    const currentAnswered = immCurrentTest.find(immQuestion => {
        return immQuestion.get('id') === questionID
    }).get('answer');

    const answerIsCoherent = !immPreviousQuestion || !immPreviousAnswerSelected
        ?   true
        :   currentAnswers.indexOf(currentAnswers.find((answer)=> answer.get('id') === immPreviousAnswerSelected.get('id'))) >=
            currentAnswers.indexOf(currentAnswers.find((answer)=> answer.get('id') === currentAnswered));
        return answerIsCoherent;

}

function coherenceValidator(immStep) {
    const immPreviousTest = getStore().getState().brokerConsultMiFID.get('questions').toArray();
    const immCurrentTest = immStep.get('products').toArray();

    const bankDepositsIsCoherent = validateByID(immPreviousTest, immCurrentTest, '145');
    const privateRentIsCoherent = validateByID(immPreviousTest, immCurrentTest, '149');
    const variableRentIsCoherent = validateByID(immPreviousTest, immCurrentTest, '153');
    const fundPlansInsurersIsCoherent = validateByID(immPreviousTest, immCurrentTest, '157');
    const structuredProductsWarrantyIsCoherent = validateByID(immPreviousTest, immCurrentTest, '161');
    const structuredProductsWithoutWarrantyIsCoherent = validateByID(immPreviousTest, immCurrentTest, '165');
    const convertibleBondsIsCoherent = validateByID(immPreviousTest, immCurrentTest, '169');
    const preferentialParticipationsIsCoherent = validateByID(immPreviousTest, immCurrentTest, BROKER_CONVENIENCE_MIFID_TEST_THIRD_STEP_FIXED_INCOME_WITH_IMPLIED_DERIVATIVES_QUESTION_ID);
    const realEstateIsCoherent = validateByID(immPreviousTest, immCurrentTest, '177');
    const ventureCapitalProductIsCoherent = validateByID(immPreviousTest, immCurrentTest, '181');
    const derivativesOrganizedMarketsIsCoherent = validateByID(immPreviousTest, immCurrentTest, '185');
    const OTCDerivativesIsCoherent = validateByID(immPreviousTest, immCurrentTest, BROKER_CONVENIENCE_MIFID_TEST_THIRD_STEP_DERIVATIVES_OTC_QUESTION_ID);

    return(
        bankDepositsIsCoherent &&
        privateRentIsCoherent &&
        variableRentIsCoherent &&
        fundPlansInsurersIsCoherent &&
        structuredProductsWarrantyIsCoherent &&
        structuredProductsWithoutWarrantyIsCoherent &&
        convertibleBondsIsCoherent &&
        preferentialParticipationsIsCoherent &&
        realEstateIsCoherent &&
        ventureCapitalProductIsCoherent &&
        derivativesOrganizedMarketsIsCoherent &&
        OTCDerivativesIsCoherent
    );

}

function validateStep(immStep, stepsState) {
    const allAnswered = immStep.get('products').find(immQuestion => !immQuestion.get('answer')) == null;
    const immSteps = Immutable.fromJS(stepsState);
    const immNewStep = immStep.set(
        'products',
        immStep.get('products').map(
            (immQuestion) => immQuestion.set('valid', !!immQuestion.get('answer'))
        )
    );
    let firstStep, secondStep, wizardFirstStep, wizardSecondStep;
    if (isRenderStep0()) {
        firstStep = SECOND_STEP;
        secondStep = THIRD_STEP;
        wizardFirstStep = WIZARD_SECOND_STEP;
        wizardSecondStep = WIZARD_THIRD_STEP;
    } else {
        firstStep = FIRST_STEP;
        secondStep = SECOND_STEP;
        wizardFirstStep = WIZARD_FIRST_STEP;
        wizardSecondStep = WIZARD_SECOND_STEP;
    }
    /*let immNewStep = immStep;

    immStep.get('products').forEach((immProduct, index) => {
        immNewStep = immNewStep.setIn(['products', index, 'valid'], immProduct.get('answer'));
    });*/

    const studyAnswer = immSteps.getIn([firstStep, 'study', 'answer']);
    const experienceAnswer = immSteps.getIn([firstStep, 'experience', 'answer']);
    const financialCultureAnswer = immSteps.getIn([secondStep, 'financialCulture', 'answer']);

    const hasUniversitaryStudy = studyAnswer === BROKER_CONVENIENCE_MIFID_TEST_FIRST_STEP_STUDY_UNIVERSITARY_ANSWER;

    const experienceMoreThanAYear = experienceAnswer === BROKER_CONVENIENCE_MIFID_TEST_FIRST_STEP_EXPERIENCE_MORE_THAN_A_YEAR_ANSWER;
    const experienceSome = experienceAnswer === BROKER_CONVENIENCE_MIFID_TEST_FIRST_STEP_EXPERIENCE_WITH_KNOWLEDGE_ANSWER;

    const hasNoFinancialCulture = financialCultureAnswer === BROKER_CONVENIENCE_MIFID_TEST_SECOND_STEP_FINANCIAL_CULTURE_NONE_ANSWER;
    const hasGeneralFinancialCulture = financialCultureAnswer === BROKER_CONVENIENCE_MIFID_TEST_SECOND_STEP_FINANCIAL_CULTURE_GENERAL_CONCEPTS_ANSWER;

    let correctlyAnswered = true;
    let invalidAnswersModalTitle = '';
    let invalidAnswersModalMessage = '';
    let stepToCheckAnswer = -1;

    if (hasNoFinancialCulture && experienceMoreThanAYear) {
        correctlyAnswered = false;
        stepToCheckAnswer = wizardFirstStep;
        invalidAnswersModalTitle = formatText('broker-convenienceMifidTestInvalidAnswerModalTitle1');
        invalidAnswersModalMessage = formatText('broker-convenienceMifidTestInvalidAnswerModalMessage1');
    } else if (hasNoFinancialCulture && experienceSome) {
        correctlyAnswered = false;
        stepToCheckAnswer = wizardFirstStep;
        invalidAnswersModalTitle = formatText('broker-convenienceMifidTestInvalidAnswerModalTitle2');
        invalidAnswersModalMessage = formatText('broker-convenienceMifidTestInvalidAnswerModalMessage2');
    } else if (hasUniversitaryStudy && hasNoFinancialCulture) {
        correctlyAnswered = false;
        stepToCheckAnswer = wizardFirstStep;
        invalidAnswersModalTitle = formatText('broker-convenienceMifidTestInvalidAnswerModalTitle3');
        invalidAnswersModalMessage = formatText('broker-convenienceMifidTestInvalidAnswerModalMessage3');
    } else if (experienceMoreThanAYear && hasGeneralFinancialCulture) {
        correctlyAnswered = false;
        stepToCheckAnswer = wizardFirstStep;
        invalidAnswersModalTitle = formatText('broker-convenienceMifidTestInvalidAnswerModalTitle4');
        invalidAnswersModalMessage = formatText('broker-convenienceMifidTestInvalidAnswerModalMessage4');
    } else if (answersStep3Incorrect(immSteps)) {
        correctlyAnswered = false;
        stepToCheckAnswer = wizardSecondStep;
        invalidAnswersModalTitle = formatText('broker-convenienceMifidTestInvalidAnswerModalTitle5');
        invalidAnswersModalMessage = formatText('broker-convenienceMifidTestInvalidAnswerModalMessage5');
    }

    let coherence = true;
    let shouldValidateCoherence = immStep.get('shouldValidateCoherence');
    if(allAnswered && correctlyAnswered && shouldCoherenceControl() && shouldValidateCoherence) {
        coherence = coherenceValidator(immStep);
        shouldValidateCoherence = !coherence;
        return immNewStep.merge({
            validated: true,
            valid: allAnswered && correctlyAnswered && coherence,
            showCoherenceModal: !coherence,
            invalidAnswersModalVisible: !correctlyAnswered,
            shouldValidateCoherence: shouldValidateCoherence,
            invalidAnswersModalTitle,
            invalidAnswersModalMessage,
            stepToCheckAnswer
        });
    }

    return immNewStep.merge({
        validated: true,
        valid: allAnswered && correctlyAnswered,
        invalidAnswersModalVisible: !correctlyAnswered,
        invalidAnswersModalTitle,
        invalidAnswersModalMessage,
        stepToCheckAnswer
    });
}

function changeProductExperience(immState, productId, answer) {
    const immProducts = immState.get('products');
    const immUpdatedProducts = immProducts.update(
        immProducts.findIndex(immProduct => immProduct.get('id') === productId),
        immProduct => immProduct.set('answer', answer)
    );
    return immState
        .set('products', immUpdatedProducts)
        .set('shouldValidateCoherence', true);
}

function updateSummary(immState) {
    const immProducts = immState.get('products');
    let summaryKey = 'broker-convenienceMifidTestStep3SummaryNoExperience';
    immProducts.toArray().forEach((product) => {
        const chosenAnswerId = product.get('answer');
        const indexAnswer = product.get('answers').indexOf(
            product.get('answers').find((immAnswer) =>
                immAnswer.get('id') === chosenAnswerId
        ));
        if (indexAnswer < 2) {
            summaryKey = 'broker-convenienceMifidTestStep3SummaryExperience';
        }
    }, summaryKey);

    return immState.set(
        'summaryDescription',
        Immutable.fromJS([formatText(summaryKey)])
    );
}

const consult = (questions) => {
    const immState = getInitialState()
    const immQuestions = Immutable.fromJS(questions);
    let immNewState = immState;

    immState.get('products').forEach((immProduct, index) => {
        const productQuestionId = immProduct.get('id');
        const immQuestion = immQuestions.find(
            immQuestion => immQuestion.get('id') == productQuestionId
        );
        const immAnswer = immQuestion
            .getIn(['respuestasArray', 'respuestasArray'])
            .find(immAnswer => immAnswer.get('seleccionado') === 'S');

        immNewState = immNewState.setIn(['products', index, 'answer'], immAnswer.get('id'));
    });

    return immNewState;
};

function brokerConvenienceMiFIDTestStep3(state = getInitialState(), action) {
    switch (action.type) {
        case BROKER_CONVENIENCE_MIFID_TEST_STEP3_CLOSE_INVALID_ANSWERS_MODAL:
        case BROKER_CONVENIENCE_MIFID_TEST_STEP3_VERIFY_ANSWERS:
            return state.set('invalidAnswersModalVisible', false);
        case BROKER_CONVENIENCE_MIFID_TEST_CONSULT:
            return consult(action.payload.questions);
        case BROKER_CONVENIENCE_MIFID_TEST_VALIDATE_STEP:
            return updateSummary(validateStep(state, action.payload.stepsState));
        case BROKER_CONVENIENCE_MIFID_TEST_STEP3_CHANGE_EXPERIENCE_AS_INVESTOR:
            const { productId, experience } = action.payload;
            return changeProductExperience(state, productId, experience);
        case BROKER_CONVENIENCE_MIFID_TEST_STEP3_CHECK_INCOHERENCES:
            return closeIncoherenceModal(state);
        case BROKER_CONVENIENCE_MIFID_TEST_STEP3_CONTINUE_WITH_INCOHERENCES:
            return continueWithIncoherences(state);
        case BROKER_CONVENIENCE_MIFID_TEST_FETCH_CURRENT_TEST_RESULT_FETCHING:
            return state.set('controlCurrTest', false);
        case BROKER_CONVENIENCE_MIFID_TEST_FETCH_CURRENT_TEST_RESULT_SUCCESS_APPROVED:
            return updateSummary(state.set('valid', true));
    default:
            return state;
    }
}

module.exports = brokerConvenienceMiFIDTestStep3;
